import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PopupPage } from './popup.page';

const routes: Routes = [
  {
    path: '',
    component: PopupPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PopupPageRoutingModule {}
